<template id="step-challenge-cards">
    <ChallengeSectionContainer title="Step Challenges"
                               tooltipText="Get a personal step goal based on your step history. Hit your step goal and get an equal share of the pot. Join with a team or individually!"
                               v-bind:isBigContainer="isBigContainer"
                               v-bind:key="challengeList.length" >
        <ChallengeCard v-for="challenge in challengeList"
                       v-bind:key="challenge.id"
                       class="step-challenge"
                       v-bind:isBigContainer="isBigContainer"
                       v-bind:src="challenge.challenge_image"
                       v-bind:title="challenge.challenge_name"
                       v-bind:type="getType(challenge)"
                       v-bind:potValue="getPotValue(challenge)"
                       v-bind:betValue="getBetValue(challenge)"
                       v-bind:teamSize="getTeamSize(challenge)"
                       v-bind:dateRange="dateRangeOf(challenge)"
                       v-bind:signUpUrl="challenge.challenge_landing_page" />
    </ChallengeSectionContainer>
</template>

<script>
import GeneralChallengeCards, { parsedPotValue } from './GeneralChallengeCards';
import ChallengeSectionContainer from './card/ChallengeSectionContainer';
import ChallengeCard from './card/ChallengeCard';

export default {
  template: '#step-challenge-cards',
  mixins: [GeneralChallengeCards],
  components: { ChallengeSectionContainer, ChallengeCard },
  data: function() {
    return {
      challengeType: 'step'
    }
  },
  methods: {
    getPotValue: function(challenge) {
      return parsedPotValue(challenge.top_price_currency, challenge.top_price);
    }
  }
}
</script>
